<template>
  <v-dialog
    :value="value"
    fullscreen
    :persistent="tipo === 'secao'"
    transition="dialog-bottom-transition"
    content-class="detalhe-dialog"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-toolbar dense flat>
        <v-toolbar-title>
          Detalhe por {{ tipo === "secao" ? "seção" : "zona" }} - {{ titulo }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="detalhe-content">
        <v-text-field
          :value="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
          class="mb-4"
          @input="onSearch"
        ></v-text-field>
        <v-row dense align="stretch" class="detalhe-body">
          <v-col cols="12" md="4" class="d-flex detalhe-ranking-col">
            <v-card outlined class="pa-3 detalhe-ranking-card">
              <div class="d-flex align-center justify-space-between mb-2">
                <h4 class="subtitle-1 font-weight-medium mb-0">
                  Ranking por assessor
                </h4>
                <span class="caption grey--text">
                  {{ formatNumber(totalGeral) }} cadastros
                </span>
              </div>
              <v-data-table
                :headers="rankingHeaders"
                :items="ranking"
                :options.sync="rankingOptions"
                :height="tableHeight"
                :loading="loadingRanking"
                dense
                fixed-header
                :no-data-text="`Sem assessores nesta ${nomeTipo}.`"
                class="detalhe-ranking-data-table"
              >
                <template v-slot:item.percentual="{ item }">
                  {{ item.percentual.toFixed(1) }}%
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="8" class="d-flex flex-column detalhe-table-col">
            <v-data-table
              :headers="detalheHeaders"
              :items="items"
              :options.sync="detalheOptions"
              :server-items-length="total"
              :loading="loading"
              :height="tableHeight"
              :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
              class="elevation-1 detalhe-table"
              fixed-header
              :no-data-text="`Sem registros para esta ${nomeTipo}.`"
            >
              <template v-slot:item.created_at="{ item }">
                {{ formatDateTime(item.created_at) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AclAPI from "../../../../api/acl";
import { formatNumber, formatDateTime } from "../utils/formatters";

const OPCOES_PADRAO = () => ({
  page: 1,
  itemsPerPage: 25,
  sortBy: ["created_at"],
  sortDesc: [true],
});

// Pessoas de uma zona (ou grupo de zonas) / seção, paginadas no servidor
// (getDetalheDistribuicao). O ranking vem pronto do servidor ao abrir.
export default {
  name: "DistribuicaoDetalheModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    tipo: {
      type: String,
      default: "zona",
    },
    titulo: {
      type: String,
      default: "",
    },
    // { zonas: ["62", ...] } ou { secao: "0567" }; "" = não informada
    filtro: {
      type: Object,
      default: () => ({}),
    },
    equipe: {
      type: [String, Number],
      default: null,
    },
    meta: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      tableHeight: "calc(80vh - 180px)",
      items: [],
      total: 0,
      ranking: [],
      totalGeral: 0,
      loading: false,
      loadingRanking: false,
      search: "",
      buscaAplicada: "",
      buscaTimer: null,
      seq: 0,
      ultimaChave: null,
      detalheHeaders: [
        { text: "ID", value: "idpessoa" },
        { text: "Nome Completo", value: "nome_completo" },
        { text: "Telefone", value: "telefone" },
        { text: "Email", value: "email" },
        { text: "Assessor", value: "assessor" },
        { text: "Zona", value: "zona" },
        { text: "Seção", value: "secao" },
        { text: "Data cadastro", value: "created_at" },
      ],
      rankingHeaders: [
        { text: "#", value: "posicao", align: "start", sortable: false },
        { text: "Assessor", value: "nome", align: "start" },
        { text: "Cadastros", value: "total", align: "end" },
        { text: "%", value: "percentual", align: "end" },
      ],
      detalheOptions: OPCOES_PADRAO(),
      rankingOptions: {
        sortBy: ["posicao"],
        sortDesc: [false],
        itemsPerPage: 10,
      },
    };
  },
  computed: {
    nomeTipo() {
      return this.tipo === "secao" ? "seção" : "zona";
    },
  },
  watch: {
    value(aberto) {
      clearTimeout(this.buscaTimer);
      if (aberto) {
        this.search = "";
        this.buscaAplicada = "";
        this.detalheOptions = OPCOES_PADRAO();
        this.carregar(true);
      } else {
        this.seq += 1;
        this.items = [];
        this.total = 0;
        this.ranking = [];
        this.totalGeral = 0;
        this.ultimaChave = null;
      }
    },
    detalheOptions: {
      handler() {
        if (this.value) this.carregar(false);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    clearTimeout(this.buscaTimer);
  },
  methods: {
    formatNumber,
    formatDateTime,
    onSearch(valor) {
      this.search = valor || "";
      clearTimeout(this.buscaTimer);
      this.buscaTimer = setTimeout(() => {
        this.buscaAplicada = this.search.trim();
        if (this.detalheOptions.page !== 1) {
          this.detalheOptions = { ...this.detalheOptions, page: 1 };
        } else {
          this.carregar(false);
        }
      }, 500);
    },
    carregar(comRanking) {
      const opcoes = this.detalheOptions;
      const params = {
        equipe: this.equipe,
        meta: this.meta,
        ...this.filtro,
        page: opcoes.page,
        per_page: opcoes.itemsPerPage > 0 ? opcoes.itemsPerPage : 100,
        search: this.buscaAplicada || undefined,
      };
      if (opcoes.sortBy && opcoes.sortBy.length) {
        params.sort_by = opcoes.sortBy[0];
        params.sort_desc = opcoes.sortDesc && opcoes.sortDesc[0] ? 1 : 0;
      }

      // O options.sync da tabela dispara o watcher com os mesmos valores: evita
      // repetir a mesma consulta.
      const chave = JSON.stringify(params);
      if (!comRanking && chave === this.ultimaChave) return;
      this.ultimaChave = chave;
      if (comRanking) params.com_ranking = 1;

      const seq = ++this.seq;
      this.loading = true;
      if (comRanking) this.loadingRanking = true;

      const headers = this.Helpers.getHeaderRequisicao();
      AclAPI.getDetalheDistribuicao(headers, params)
        .then((response) => {
          if (seq !== this.seq) return;
          const { data } = response;
          if (data.token) localStorage.setItem("token", data.token);

          this.items = data.pessoas || [];
          this.total = Number(data.total) || 0;

          if (data.ranking) {
            const totalGeral = data.ranking.reduce((acc, r) => acc + Number(r.total), 0);
            this.totalGeral = totalGeral;
            this.ranking = data.ranking.map((r, index) => ({
              nome: r.nome || "Não informado",
              total: Number(r.total),
              percentual: totalGeral > 0 ? (Number(r.total) / totalGeral) * 100 : 0,
              posicao: index + 1,
            }));
          }
        })
        .catch((error) => {
          if (seq !== this.seq) return;
          if (error.response && error.response.status === 401) {
            this.Helpers.logout();
            return;
          }
          this.$store.dispatch("snackbar/showSnackbar", {
            message: "Erro ao carregar os cadastros. Tente novamente.",
            color: "error",
          });
        })
        .finally(() => {
          if (seq !== this.seq) return;
          this.loading = false;
          this.loadingRanking = false;
        });
    },
  },
};
</script>

<style scoped>
.detalhe-dialog ::v-deep .v-card {
  height: 100vh;
}

.detalhe-dialog ::v-deep .v-card__text {
  height: calc(100vh - 96px);
  overflow: hidden;
}

.detalhe-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.detalhe-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  height: 100%;
}

.detalhe-ranking-col {
  min-height: 0;
  overflow: hidden;
  max-width: 100%;
}

.detalhe-ranking-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.detalhe-ranking-data-table {
  max-width: 100%;
  overflow-x: auto;
}

.detalhe-ranking-data-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
  max-height: calc(100% - 59px) !important;
  overflow-x: auto !important;
}

.detalhe-ranking-data-table.v-data-table--dense td,
.detalhe-ranking-data-table.v-data-table--dense th {
  padding: 0 8px !important;
}

.detalhe-ranking-data-table ::v-deep .v-data-footer {
  position: sticky !important;
  bottom: 0 !important;
  background-color: white !important;
  border-top: thin solid rgba(0, 0, 0, 0.12) !important;
}

.detalhe-table-col {
  min-height: 0;
}

.detalhe-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
}
</style>
